import React from 'react';
import { UserPermissionGroup, UserPermissions } from '../../contexts/user-permissions-context/types';
import { useUserPermissionsContext } from '../../contexts/user-permissions-context/UserPermissionsContext';

type UserPermissionGroups = readonly UserPermissionGroup[];

type SelectedUserPermissions<T extends UserPermissionGroups> = Pick<UserPermissions, T[number]>;

export type UseUserPermissionsResult<T extends UserPermissionGroups> = SelectedUserPermissions<T>;

export default function useUserPermissions<T extends UserPermissionGroups>(
  groups: T,
): SelectedUserPermissions<T> {
  const { getPermissions } = useUserPermissionsContext();

  return React.useMemo(
    () => Object.fromEntries(
      groups.map((group) => [
        group,
        getPermissions(group),
      ]),
    ) as SelectedUserPermissions<T>,
    [groups, getPermissions],
  );
}
